var isDarkModePreferred = false

export default {
    posts: (state) => {
        return state.posts
    },
    profile: (state, getters, rootState, rootGetters) => {
        return rootGetters['auth/current_user']
    },
    favouriteAccounts(state) {
        return state.favouriteAccounts
    },
    isFavouriteAccount(state, getters) {
        return (id) => getters.favouriteAccounts.any((account) => account.id === id)
    },
    theme: (state) => {
        return state.theme
    },
    isThemeDark(state, getters) {
        return getters.themeMode === 'dark'
    },
    isThemeSemiDark(state, getters) {
        return getters.themeMode === 'semi-dark'
    },
    isNavBarDark(state, getters) {
        return getters.isThemeDark || getters.isThemeSemiDark
    },
    themeMode(state) {
        if (state.theme.theme === 'auto') {
            if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
                return 'dark'
            }
            return 'semi-dark'
        }
        return state.theme.theme
    },
    primaryColor(state, getters) {
        return getters.theme.colors.primary
    }
}
